import React, { useRef, useState } from 'react'
import styled from 'styled-components';
import useAsyncEffect from 'use-async-effect';
import { loading } from '../../actions/Loading';
import api from '../../api/api';
import { useDispatch } from 'react-redux';
import { List } from '../../model/List';
import SortableTable from '../table/SortableTable';
import AnimatedSaveButton from '../AnimatedSaveButton';
import AlertEx from '../AlertEx';
import moment from 'moment'

interface IProps {
    stockId: string;
}

const Style = styled.div`
margin: 1rem 0;

.flex {
    display: flex;
    justify-content: space-between;
}
table {
    margin-top: 0.5rem;
}
.sample-file {
    font-size:0.65rem;
    font-style: italic;
}

`;

const getHeaders = () =>  {
    return [ 'Email', 'Name', 'Status', 'Source', 'Created' ];
}

const ContactComponent: React.FC<IProps> = (props: IProps) => {

    const dispatch = useDispatch();
    const [ item, setItem ] = useState<List>();
    const [ canUpload, setCanUpload ] = useState<boolean>(false);
    const [ openActionRow, setOpenActionRow ] = useState<number | null>(null);


    const fileInput = React.createRef<any>();
    const contactCsvFile = useRef<FileList | null>(null);
    const onFileChange = (selectorFiles: FileList|null) =>   {
        contactCsvFile.current = selectorFiles;
        setCanUpload(contactCsvFile != null && contactCsvFile.current != null && contactCsvFile.current.length > 0);
    }     


    const uploadCsv = async () : Promise<boolean> => {
        let file = contactCsvFile!.current![0];
        const result = await api().uploadContactCsv({
            file,
            stockId: props.stockId
        });
        if (result.errorMessage) {
            AlertEx(`${result.errorMessage}`);
        } else {
            const result = await api().getContactList(props.stockId);
            setItem(result);
        }
        return true;
    }

    const addSubscriber = async () => {
        const email = prompt('Enter subscriber email address:');
        if (!email || !email.trim()) {
            return;
        }

        const name = prompt('Enter subscriber name:');
        if (!name || !name.trim()) {
            return;
        }

        // Split name into first and last (first word = first name, rest = last name)
        const nameParts = name.trim().split(' ');
        const firstName = nameParts[0] || '';
        const lastName = nameParts.slice(1).join(' ') || '';

        // Create a CSV with the email and name
        const csvContent = `Email,LastName,FirstName,Status\n${email.trim()},${lastName},${firstName},subscribed`;
        const blob = new Blob([csvContent], { type: 'text/csv' });
        const file = new File([blob], 'subscriber.csv', { type: 'text/csv' });

        // Create a FileList-like object
        const dataTransfer = new DataTransfer();
        dataTransfer.items.add(file);
        contactCsvFile.current = dataTransfer.files;

        // Upload the CSV
        await uploadCsv();

        // Clear the file input
        contactCsvFile.current = null;
        setCanUpload(false);
    }

    const markAsUnsubscribed = async (email: string, name: string) => {
        if (!confirm(`Mark ${email} as unsubscribed?`)) {
            return;
        }

        // Split name into first and last (first word = first name, rest = last name)
        const nameParts = name.trim().split(' ');
        const firstName = nameParts[0] || '';
        const lastName = nameParts.slice(1).join(' ') || '';

        // Create a CSV with unsubscribed status
        const csvContent = `Email,LastName,FirstName,Status\n${email.trim()},${lastName},${firstName},unsubscribed`;
        const blob = new Blob([csvContent], { type: 'text/csv' });
        const file = new File([blob], 'unsubscribe.csv', { type: 'text/csv' });

        // Create a FileList-like object
        const dataTransfer = new DataTransfer();
        dataTransfer.items.add(file);
        contactCsvFile.current = dataTransfer.files;

        // Upload the CSV
        await uploadCsv();

        // Clear the file input
        contactCsvFile.current = null;
        setCanUpload(false);
    }

    useAsyncEffect(async (isMounted:()=>boolean)=> {
        
        dispatch(loading(true));
        const result = await api().getContactList(props.stockId);
        if(isMounted()){
            setItem(result)   
        }
        dispatch(loading(false));
        
        
      }, []);

      const data:any[][] = [];
      let subscribedCount = 0;
      if(item){
          for(let i = 0; i < item.subscribers.length; i++){
              const subscriber = item.subscribers[i];
              let arr:any[] = []

              arr = [
                  subscriber.email,
                  subscriber.name,
                  subscriber.status,
                  subscriber.source || 'email',
                  moment(subscriber.created,).format('DD MMM YY'),
                  subscriber  // Add the full model object as the last element
              ]


              data.push(arr)
          }
          subscribedCount = item.subscribers.filter(x=>x.status==='subscribed').length
      }

      const cellFormatter = (columnName: string, cellData: any, subscriber: any) => {
          // Status column with action
          if (columnName === 'Status') {
              const rowIndex = data.findIndex(row => row[5] === subscriber);
              const isOpen = openActionRow === rowIndex;

              return (
                  <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', position: 'relative' }}>
                      <span>{cellData}</span>
                      {subscriber?.status === 'subscribed' && (
                          <>
                              <a
                                  href="#"
                                  onClick={(e) => {
                                      e.preventDefault();
                                      setOpenActionRow(isOpen ? null : rowIndex);
                                  }}
                                  style={{ cursor: 'pointer', fontWeight: 'bold' }}
                              >
                                  &gt;&gt;
                              </a>
                              {isOpen && (
                                  <div style={{
                                      position: 'absolute',
                                      left: '0',
                                      top: '100%',
                                      marginTop: '0.25rem',
                                      whiteSpace: 'nowrap',
                                      backgroundColor: 'white',
                                      border: '1px solid #ccc',
                                      padding: '0.25rem 0.5rem',
                                      borderRadius: '3px',
                                      boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                                      zIndex: 1000
                                  }}>
                                      <a
                                          href="#"
                                          onClick={(e) => {
                                              e.preventDefault();
                                              markAsUnsubscribed(subscriber.email, subscriber.name);
                                              setOpenActionRow(null);
                                          }}
                                      >
                                          Mark as Unsubscribed
                                      </a>
                                  </div>
                              )}
                          </>
                      )}
                  </div>
              );
          }
          return null;
      }

    const downloadCSV = () => {
  const csvContent = `Email,LastName,FirstName,Status
john.smith@example.com,Smith,John,subscribed
investor1@example.com,Johnson,Sarah,subscribed`;

  const blob = new Blob([csvContent], { type: 'text/csv' });
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = 'subscribers.csv';
  link.click();
  window.URL.revokeObjectURL(url);
};

    return <Style >
        <div className='flex'>
      <h2>Contacts</h2>
            <div>
                <div className="form-item">
                    { !canUpload && <label htmlFor="">Select Contact CSV file</label>}

                    { canUpload && <AnimatedSaveButton onClick={uploadCsv} startingText="Start Upload" progressText="Uploading..." completedText="Uploaded!"  />}
                    <input type="file" accept=".csv"
                        ref={fileInput}
                        onChange={(e) => onFileChange(e.target.files)}
                    />
                    <button className='button-sm link button-as-link sample-file' onClick={downloadCSV}>Download Sample CSV</button>
                </div>

            </div>


            </div>
        { !!item && <>
        <div className='flex'>
            <div>{ subscribedCount } subscribed of { item.subscribers.length } total</div>
            <div>
                <button className='button-sm' onClick={addSubscriber}>Add Subscriber</button>
            </div>
        </div>
        <p> </p>
        <SortableTable headers={getHeaders()} data={data} cellFormatter={cellFormatter}  />
        </>}
    </Style>
}

export default ContactComponent;